import { Typography } from "@mui/material";
import Flex from "frontend/commons/Flex";
import { HiOutlineLocationMarker, HiOutlineMail, HiOutlinePhone } from "react-icons/hi";
import './AgencyCardContent.css';
import { useSelector } from "react-redux";

export default function AgencyCardContent({ agency }) {
  const { geo } = useSelector((state) => state.applicationState);

  const getAgencyLocationData = (agency) => {
    if (!geo) return;
    const { localities } = geo;

    const filteredLocality = localities.data.find((locality) => locality.id === agency.localidadId);
    return filteredLocality
  }

  const location = getAgencyLocationData(agency);
  
  return (
        <Flex vertical className="agencies__card__content">
          <div className="agencies__card__header">
            <Typography variant="h6" component="div">
              {agency.nombre}
            </Typography>
          </div>
          <Flex className="agencies__card__row">
            <HiOutlineMail size={24} className="agency__card__icon" />
            <div className="agency__card__content__text">
              <Typography variant="body2" component="div">
                {agency.email}
              </Typography>
            </div>
          </Flex>
          <Flex className="agencies__card__row">
            <HiOutlineLocationMarker size={24} className="agency__card__icon" />
            <div className="agency__card__content__text">
              <Typography variant="body2" component="div">
                {agency.direccion}, {location?.nombre},{' '}
                {location?.provincia.nombre}, {location?.provincia.pais.nombre}
              </Typography>
            </div>
          </Flex>
          <Flex className="agencies__card__row">
            <HiOutlinePhone size={24} className="agency__card__icon" />
            <div className="agency__card__content__text">
              <Typography variant="body2" component="div">
                {agency.telefono}
              </Typography>
            </div>
          </Flex>
        </Flex>
  )
}
